const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 64,
    height: 64,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#ff004f",
    d: "M91.95 46.205c8.264 5.905 18.389 9.38 29.324 9.38V34.553c-2.07 0-4.134-.216-6.158-.644v16.555a50.3 50.3 0 0 1-29.325-9.38v42.92c0 21.471-17.415 38.876-38.895 38.876a38.72 38.72 0 0 1-21.653-6.576C32.306 123.522 42.156 128 53.053 128c21.482 0 38.897-17.404 38.897-38.876zm7.596-21.218A29.3 29.3 0 0 1 91.95 7.825V5.12h-5.836c1.47 8.375 6.48 15.53 13.433 19.867M38.83 99.828a17.7 17.7 0 0 1-3.63-10.765c0-9.82 7.966-17.782 17.793-17.782 1.83 0 3.651.28 5.397.833V50.612a39 39 0 0 0-6.156-.354v16.736a17.8 17.8 0 0 0-5.4-.833c-9.827 0-17.792 7.961-17.792 17.782 0 6.945 3.982 12.957 9.788 15.885",
    style: {
      strokeWidth: 0.439289
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.79 41.084a50.3 50.3 0 0 0 29.326 9.38V33.907a29.44 29.44 0 0 1-15.57-8.921C92.592 20.65 87.582 13.495 86.113 5.12h-15.33v84.003c-.034 9.793-7.986 17.723-17.791 17.723-5.779 0-10.912-2.753-14.164-7.018-5.805-2.928-9.786-8.94-9.786-15.884 0-9.82 7.964-17.783 17.791-17.783 1.883 0 3.698.293 5.4.833V50.258c-21.103.436-38.075 17.67-38.075 38.866 0 10.58 4.226 20.172 11.086 27.18a38.73 38.73 0 0 0 21.652 6.576c21.481 0 38.895-17.405 38.895-38.875v-42.92Z",
    style: {
      strokeWidth: 0.439289
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00f2ea",
    d: "M115.116 33.908v-4.476a29.33 29.33 0 0 1-15.57-4.446 29.4 29.4 0 0 0 15.57 8.922M86.113 5.12q-.21-1.2-.322-2.415V0H64.625v84.004c-.034 9.792-7.985 17.722-17.792 17.722-2.879 0-5.597-.683-8.005-1.897 3.252 4.264 8.385 7.017 14.164 7.017 9.805 0 17.757-7.93 17.792-17.722V5.12Zm-33.88 45.138v-4.765a39 39 0 0 0-5.336-.362C25.414 45.13 8 62.535 8 84.004c0 13.46 6.844 25.322 17.244 32.3-6.86-7.008-11.086-16.6-11.086-27.18 0-21.196 16.972-38.43 38.076-38.866",
    style: {
      strokeWidth: 0.439289
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.57bb558eb46b02ef4e26a1ec980807cc.svg";
export { ForwardRef as ReactComponent };